/* Style Icons (sections/sava-style-icons.liquid): open a look in a bottom sheet, add one product or the full look. */
if (!customElements.get('sava-style-icons')) {
  customElements.define('sava-style-icons', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.overlay = this.querySelector('[data-si-overlay]');
      this.sheet = this.querySelector('[data-si-sheet]');
      this.body = this.querySelector('[data-si-body]');
      this.allBtn = this.querySelector('[data-si-all]');
      document.body.appendChild(this.overlay); // escape transformed/overflow parents
      this.addEventListener('click', (e) => {
        const open = e.target.closest('[data-si-open]');
        if (open) this.open(open.closest('.sava-si__card'), open);
      });
      this.overlay.addEventListener('click', (e) => {
        if (e.target.closest('[data-si-close]')) return this.close();
        const add = e.target.closest('[data-si-add]');
        if (add) return this.addOne(add);
        if (e.target.closest('[data-si-all]')) this.addAll();
      });
      this.overlay.addEventListener('keyup', (e) => { if (e.key === 'Escape') this.close(); });
      this.overlay.addEventListener('change', (e) => { if (e.target.matches('[data-si-variant]')) e.target.classList.remove('is-error'); });
      this.setupSwipe();
    }

    open(card, opener) {
      this.opener = opener;
      this.body.innerHTML = '';
      this.body.appendChild(card.querySelector('template[data-si-look]').content.cloneNode(true));
      this.allBtn.disabled = false;
      this.overlay.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(() => requestAnimationFrame(() => this.overlay.classList.add('is-open')));
      setTimeout(() => this.sheet.querySelector('[data-si-close].sava-si__x')?.focus({ preventScroll: true }), 300);
    }

    close(then) {
      this.overlay.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(() => { this.overlay.hidden = true; this.sheet.style.transform = ''; if (then) then(); else this.opener?.focus({ preventScroll: true }); }, 280);
    }

    variantOf(item) {
      const sel = item.querySelector('[data-si-variant]');
      if (!sel) return Number(item.dataset.variantId);
      if (!sel.value) return null; // size not chosen yet
      return Number(sel.value);
    }

    // Products with sizes: no default size. Mark the select(s) still empty; returns false if any is missing.
    checkSizes(items) {
      let first = null;
      items.forEach((i) => {
        const sel = i.querySelector('[data-si-variant]');
        const missing = sel && !sel.value;
        if (sel) sel.classList.toggle('is-error', missing);
        if (missing && !first) first = sel;
      });
      if (first) {
        first.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        first.focus({ preventScroll: true });
        return false;
      }
      return true;
    }

    async post(ids) {
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.section) : [];
      const res = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: ids.map((id) => ({ id, quantity: 1, properties: { _style_icons: '1' } })),
          sections,
          sections_url: window.location.pathname,
        }),
      }).then((r) => r.json());
      if (res.status) throw new Error(res.description || res.message);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sava-style-icons', cartData: res });
      }
      return { res, drawer };
    }

    async addOne(btn) {
      const item = btn.closest('[data-si-item]');
      if (!this.checkSizes([item])) return;
      btn.classList.add('is-loading');
      try {
        const { res, drawer } = await this.post([this.variantOf(item)]);
        if (drawer && res.sections) drawer.renderContents(res, false); // update cart + count, keep the sheet open
        btn.textContent = this.allBtn.dataset.addedLabel || '✓ ADDED';
        btn.classList.add('is-done');
      } catch (e) {
        console.error('style-icons', e);
      } finally {
        btn.classList.remove('is-loading');
      }
    }

    async addAll() {
      const items = [...this.body.querySelectorAll('[data-si-item]')];
      if (!items.length || !this.checkSizes(items)) return;
      this.allBtn.classList.add('is-loading');
      try {
        const { res, drawer } = await this.post(items.map((i) => this.variantOf(i)));
        this.close(() => { if (drawer && res.sections) drawer.renderContents(res); });
      } catch (e) {
        console.error('style-icons', e);
      } finally {
        this.allBtn.classList.remove('is-loading');
      }
    }

    setupSwipe() {
      const grip = this.sheet;
      let y0 = null; let dy = 0;
      grip.addEventListener('touchstart', (e) => {
        if (this.body.scrollTop > 0 && this.body.contains(e.target)) return;
        y0 = e.touches[0].clientY; dy = 0;
      }, { passive: true });
      grip.addEventListener('touchmove', (e) => {
        if (y0 === null) return;
        dy = Math.max(0, e.touches[0].clientY - y0);
        this.sheet.style.transition = 'none';
        this.sheet.style.transform = `translateY(${dy}px)`;
      }, { passive: true });
      grip.addEventListener('touchend', () => {
        if (y0 === null) return;
        this.sheet.style.transition = '';
        if (dy > 80) this.close(); else this.sheet.style.transform = '';
        y0 = null;
      });
    }
  });
}
